module.exports = __webpack_public_path__ + "img/exclude.7f1ff77b.svg";